<template>
	<b-card>
		<div slot="header">
			<b-row>
				<b-button @click="cancelAndBack" class="ml-3 mr-1 fa fa-arrow-circle-left" variant="dark" style="font-size: 22px; padding: 0 10px;"/>
				<b-col>
					<multiselect
						v-model="dep"
						:options="departments"
						:disabled="depDisable"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						label="name"
						:placeholder="$t('promo-to-product.department')"
						class="multiselect-pricing"
					/>
				</b-col>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:disabled="!dep"
						:options="items"
						:searchable="true"
						:show-labels="false"
						:close-on-select="true"
						:internal-search="false"
						@select="addItem($event)"
						v-model="item"
						class="multiselect-pricing"
						@search-change="getItems($event)"
						:placeholder="$t('restaurant.product')"
					>
						<template slot="option" slot-scope="props">
							<b>{{ props.option.barcode }}</b> / {{ props.option.name }} / <b>€ {{ props.option.priceUzs }}</b>
						</template>
					</multiselect>
				</b-col>
				<b-button v-if="dep" @click="cancel" class="mr-2 fa fa-close" variant="danger" style="font-size: 22px; padding: 0 10px;"/>
				<b-button v-if="dep" @click="submit" class="mr-3 fa fa-check-circle" variant="success" style="font-size: 22px; padding: 0 10px;"/>
			</b-row>
		</div>
		<b-row class="mt-3">
			<b-col>
				<table id="table" class="table-striped table-bordered table-hover" style="width: 100%">
					<thead>
					<tr>
						<th class="text-center">{{ '№' }}</th>
						<th class="text-center">{{ $t('goods.special-barcode') }}</th>
						<th class="text-center">{{ $t('goods.name') }}</th>
						<th class="text-center">{{ $t('client.create.customer') }}</th>
						<th class="text-center">{{ $t('client.create.category') }}</th>
						<th class="text-center">{{ $t('incomes.create.price') }}</th>
						<th class="text-center">{{ $t('incomes.balance') }}</th>
						<th class="text-center">{{ $t('sale.kol-vo') }}</th>
						<th class="text-center">{{ '#' }}</th>
					</tr>
					</thead>
					<tbody v-for="(item, index) in localItems" :key="`table-${index}`">
					<tr>
						<td class="text-center">{{ index+1 }}</td>
						<td class="text-center">{{ item.barcode }}</td>
						<td class="text-left">{{ item.name }}</td>
						<td class="text-center">{{ item.subName }}</td>
						<td class="text-center">{{ item.sub2Name }}</td>
						<td class="text-center">€ {{ item.priceUzs }}</td>
						<td class="text-center">{{ item.remaining }}</td>
						<td class="text-center">
							<b-input v-model="item.count" :name="`count-${index}`" type="number" :min="1" :max="item.remaining"/>
						</td>
						<td class="text-center">
							<span class="fa fa-trash text-danger" style="cursor: pointer; font-size: 15px" @click="deleteItem(index)"/>
						</td>
					</tr>
					<tr>
						<td colspan="9">
							<table style="width: 99%; margin: 10px">
								<thead>
								<tr>
									<th class="text-center">{{ '№' }}</th>
									<th class="text-center">{{ $t('goods.special-barcode') }}</th>
									<th class="text-center">{{ $t('goods.name') }}</th>
									<th class="text-center">{{ $t('incomes.create.price') }}</th>
									<th class="text-center">{{ $t('sale.kol-vo') }}</th>
									<th class="text-center">{{ $t('warehouse.item.total') }}</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="(child, ind) in item.wrappedItems" :key="`child-${ind}`">
									<td class="text-center">{{ ind+1 }}</td>
									<td class="text-center">{{ child.barcode }}</td>
									<td class="text-center">{{ child.name }}</td>
									<td class="text-center">
										<b-form-input v-model="item.wrappedPrices[child.wrappedId]" type="number" name="priceUzs"/>
									</td>
									<td class="text-center">{{ child.amount }}</td>
									<td class="text-center">
										<span>{{getTotal(child, item) ? getTotal(child, item) : 0}}</span>
									</td>
								</tr>
								</tbody>
							</table>
						</td>
					</tr>
					</tbody>
					<tbody v-if="localItems.length === 0">
					<tr>
						<td colspan="9" class="text-center"><h4>{{ $t('empty') }}</h4></td>
					</tr>
					</tbody>
				</table>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect"
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";

export default {
	name: "CreateOrUpdate",
	components: {Multiselect},
	data() {
		return {
			items: [],
			localItems: [],
			departments: [],
			dep: null,
			name: '',
			loading: false,
			depDisable: false,
			item:null
		}
	},
	watch:{
	'dep':{
		handler(g){
			if (g !== null){
				let link = `?depIds=${this.dep.id}&catId=14&wrapped=true&search=${this.item}&subId=null&sub2Id=null&sub3Id=null&genderId=null&brandId=null&colorId=null`
				WhDocument.getItemsForItemConvertService({link: link}).then(res => {
					if (res) {
						this.items = res
						this.depDisable = true
					}
				})
			}
		}
	},
	},
	methods: {
		getTotal(child, item) {
			return child.amount * item.count
		},
		search($event) {
			this.name = $event
			this.getItems();
		},
	async	getItems(dep) {
			this.loading = true
				let link = `?depIds=${this.dep.id}&catId=14&wrapped=true&search=${this.name}&subId=null&sub2Id=null&sub3Id=null&genderId=null&brandId=null&colorId=null`
				await WhDocument.getItemsForItemConvertService({link: `?depIds=${this.dep.id}&catId=14&wrapped=true&search=${dep}&subId=null&sub2Id=null&sub3Id=null&genderId=null&brandId=null&colorId=null`}).then(res => {
					if (res) {
						this.items = res
						this.depDisable = true
					}
				})
			this.loading = false
		},
		cancel() {
			this.dep = null
			this.items = []
			this.localItems = []
			this.depDisable = false
		},
		cancelAndBack() {
			this.dep = null
			this.items = []
			this.localItems = []
			this.depDisable = false
			this.$router.go(-1);
		},
		submit() {
			this.$bvModal.msgBoxConfirm('Действительно хотите сохранить и закончить?', {
				title: 'Подтвердите!',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'Да',
				cancelTitle: 'Нет',
				centered: true
			}).then(value => {
				if (value) {
					WhDocument.unConvert(this.dep.id, this.localItems).then(res => {
						this.cancelAndBack();
						this.$vs.notify({
							title: this.$t('action_success'),
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				}
			}).catch(err => {
				// An error occurred
			})
		},
		addItem(item) {
			if (this.localItems.length > 0) {
				let tmp = true
				this.localItems.forEach(t => {
					if (t.itemId === item.itemId && t.priceUzs === item.priceUzs)
						tmp = false
				})
				if (tmp) {
					let obj = {
						itemId: item.itemId,
						departmentId: this.dep.id
					}
					WhDocument.getViewPRoductItems(obj).then(res => {
						item.wrappedItems = res.data
						item.wrappedPrices = {}
						item.wrappedItems.forEach(t => {
							item.wrappedPrices[t.wrappedId] = t.priceUzs
						})
						item._showDetails = true
						this.localItems.unshift(item)
						this.$forceUpdate();
					})
				}
			} else {
				let obj = {
					itemId: item.itemId,
					departmentId: this.dep.id
				}
				WhDocument.getViewPRoductItems(obj).then(res => {
					item.wrappedItems = res.data
					item.wrappedPrices = {}
					item.wrappedItems.forEach(t => {
						item.wrappedPrices[t.wrappedId] = t.priceUzs
					})
					item._showDetails = true
					this.localItems.unshift(item)
					this.$forceUpdate();
				})
			}
		},
		deleteItem(index) {
			this.localItems.splice(index, 1);
			this.$forceUpdate();
		}
	},
	created() {
		UsersService.getPermittedDepartments().then(res => {
			this.departments = res.data.permittedDepartments
		})
	}
}
</script>

<style scoped>

</style>
